// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcl_a bhc_cw bhc_jx bhc_jo bhc_rh bhc_vf"};